import {create} from 'zustand';

import {AdvanceDiagnosticsBookingStore} from './types';

export const useAdvanceDiagnosticsBookingStore = create<AdvanceDiagnosticsBookingStore>(set => ({
	step: 'idle',
	setStep: step => set({step}),
	startAdvanceDiagnosticsBooking: () => set({step: 'confirmation'}),
	closeAdvanceDiagnosticsBooking: () => set({step: 'idle'}),
}));
